const config = {};
window.config = config;
